module.exports = __webpack_public_path__ + "img/ykdx-logo3.bb2e12ba.png";